import React, { useState } from 'react';
import { authFetch } from '../auth';

const API = process.env.REACT_APP_API_URL || 'http://localhost:8000';

export default function DownloadButton({ deckId }) {
  const [loading, setLoading] = useState(false);

  if (!deckId) return null;

  const handleDownload = async () => {
    setLoading(true);
    try {
      const res = await authFetch(`${API}/download/${deckId}`);
      if (!res.ok) throw new Error('Download failed');
      const blob = await res.blob();
      const url = URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;
      a.download = `${deckId}.pptx`;
      a.click();
      URL.revokeObjectURL(url);
    } catch (e) {
      alert('Download failed. Please try regenerating the presentation.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <button
      onClick={handleDownload}
      className="btn-download"
      disabled={loading}
      aria-label="Download PowerPoint"
    >
      {loading ? '⏳ Downloading...' : '⬇ Download .pptx'}
    </button>
  );
}
